<template>
  <div class="hc-hexapie">
    <svg :style="style" class="hc-hexapie-chart">
      <g
        v-for="(text, index) in texts"
        :key="index"
        :transform="getLegendPosition(index, texts.length)"
        class="hc-hexapie-legend"
      >
        <hexagon :fill="colors[index]"/>
        <text dy="8" dx="22">{{text}}</text>
      </g>
      <pie
        :transform="transform"
        :data="data"
        :scale="scale"
        :radius="radius"
        :colors="colors"
        :animation="animation"
        :animationDuration="animationDuration"
        :animationOptions="animationOptions"
        :clip-path="clip"
      ></pie>
      <defs>
        <clipPath :id="domId" :transform="transformHexagone">
          <hexagon-path
            :curve="curve"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
import Pie from '../shapes/Pie'
import HexagonPath from '../shapes/HexagonPath'
import Hexagon from '../shapes/Hexagon'
export default {
  name: 'HexaPieChart',
  components: {
    Pie,
    HexagonPath,
    Hexagon
  },
  props: {
    data: {
      type: Array,
      default () { return [] }
    },
    texts: {
      type: Array,
      default () { return [] }
    },
    radius: {
      type: Number,
      default: 116
    },
    colors: {
      type: Array,
      default () { return ['#666666', '#f56043'] }
    },
    curve: {
      type: Number,
      default: 0.8
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    }
  },
  data () {
    return {
      width: 390,
      height: 234
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  methods: {
    resize () {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
    },
    getLegendPosition (index, length) {
      //return `translate(0 ${(234 * this.scale**2 / 2) + 24 * this.scale**2 * ((length - 2)/2 - index)}) scale(${this.scale**2 / 2})`
      return `translate(17, ${(this.height/2 + (index - (length - 1) / 2) * 44)}) scale(${this.scale**2 / 2})`
    }
  },
  computed: {
    style () {
      return { height: `${this.height}px`, width: `${this.width}px` }
    },
    scale () {
      return Math.min(Math.sqrt(this.width) / 17.75, Math.sqrt(this.height) / 15.3)
    },
    transformHexagone () {
      return `rotate(90) scale(${this.scale * 8})` // 8 is the safe scale
    },
    transform () {
      return `translate(${this.width * .67} ${this.height * .5}) rotate(90) scale(${this.scale * .9})` // this.width * .67 is the safe offset
    },
    domId () {
      return `hc-cut-hexa${this._uid}`
    },
    clip () {
      return `url(#hc-cut-hexa${this._uid})`
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>

</style>
